import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { combineLatest, take } from "rxjs";
import { depositTrx, paymentTrx } from "src/app/router-translation.labels";
import { LatestWinsService } from "src/app/services/page/latest-winners.service";
import { CrossSellUserDataService, levels } from "src/app/services/profile/cross-sell-data.service";
import { TranslationConfig } from "src/app/utils/translate-config";

@Component({
  selector: 'app-cross-sell-bonus-dialog',
  templateUrl: './cross-sell-bonus-dialog.component.html',
  styleUrls: ['./cross-sell-bonus-dialog.component.scss'],
})
export class CrossSellBonusDialogComponent {
  currencySymbol: string = this.data.symbol;
  totalPrizeAmount: number = this.data.amount;
  isReadyAmount: boolean = this.data.ready;
  isReadyGamification: boolean = false;
  isDesktop: boolean = this.data.isDesktop;
  readonly depositUrl = this.translationConfig.getTranslation(paymentTrx) + '/' + this.translationConfig.getTranslation(depositTrx);
  currencyValue: number;
  userGamificationLevel: number;
  userGamificationAmount: number;
  baseMinDepositAmount: number = 5;
  levels = {
    'LOW': 125,
    'MID': 150,
    'HIGH': 200
  }

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<CrossSellBonusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public translationConfig: TranslationConfig,
    public latestWinsService: LatestWinsService,
    private crossSellUserDataService: CrossSellUserDataService
  ) {}

  ngOnInit() {
    this.crossSellUserDataService.getCurrencyMultiplier().pipe(take(1)).subscribe(resp => {
      this.currencyValue = resp;
    });
    this.getUserGamification();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  redirectToDeposit() {
    this.router.navigate([this.depositUrl]);
    this.closeDialog();
  }

  getUserGamification() {
    this.crossSellUserDataService.getGamificationLevel().subscribe(gamification => {
      this.userGamificationLevel = this.levels[gamification];
      this.userGamificationAmount = this.userGamificationLevel * this.currencyValue;
      this.isReadyGamification = true;
    })
  }
}